import React, { useState } from "react";
import { useSelector } from "react-redux";
import museumsData from "../Attraction/Museum/museumsData"
import monumentsData from "../Attraction/monument/fortContent"
import { Link } from "react-router-dom";


const Gallery = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const [activeTab, setActiveTab] = useState("photo");
  const [zoomImage, setZoomImage] = useState(null);

  const content = {
    English: {
      title: "Gallery",
      breadcrumb: {
        home: "HOME",
        page: "GALLERY",
      },
      heading: `Museum`,
      heading2: `Monuments`,
      heading3: `Satara Region Museum`,
      heading4: `Shrigaon Fort`,
      heading5: `Coming soon...`
    },
    मराठी: {
      title: "दालन",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "दालन",
      },
      heading: `संग्रहालय`,
      heading2: `स्मारके`,
      heading3: `सातारा प्रादेशिक संग्रहालय`,
      heading4: `शिरगाव किल्ला`,
      heading5: `लवकरच येत आहे...`
    },
  };
  const t = content[selectedLang];

  const museumItems = museumsData.map((museum) => ({
    id: museum.id,
    title: museum.content[selectedLang]?.title || museum.content["English"].title,
    image: museum.image,
  }));

  const monumentItems = Object.entries(monumentsData).map(([id, content]) => ({
    id,
    title: content[selectedLang]?.title || content["English"].title,
    image: content["English"].imageGroup?.[0], // fallback to first image
  }));

  const categories = [
    { key: "photo", label: { English: "Photo Gallery", मराठी: "छायाचित्र दालन" } },
    { key: "video", label: { English: "Video Gallery", मराठी: "चलचित्र दालन" } },
    { key: "event", label: { English: "Event Gallery", मराठी: "कार्यक्रम दालन" } },
  ];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-12">
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline" style={{ color: "#DD9827" }}>
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      {/* Category Buttons */}
      <div className="flex flex-wrap justify-center gap-4 my-8 px-4 no-dark-bg">
        {categories.map((cat) => (
          <button
            key={cat.key}
            onClick={() => setActiveTab(cat.key)}
            className={`tab-button w-full font-futura sm:w-auto px-6 py-2 border border-orange-500 rounded-md transition duration-300 font-medium text-center ${activeTab === cat.key
              ? "active-tab"
              : "hover:bg-[#DD9827] hover:text-white border-[#DD9827]"
              }`}
          >
            {cat.label[selectedLang]}
          </button>
        ))}
      </div>

      {/* Museum Section - shown in all tabs */}
      {activeTab === "photo" ? (
        <>
          <div className="px-4 sm:px-6 md:px-12 lg:px-16 py-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-6 text-center">
              {t.heading}
            </h2>
            <div className="flex flex-wrap justify-center gap-6">
              {museumItems.map((item) => (
                <div
                  key={item.id}
                  className="w-full sm:w-[48%] md:w-[30%] lg:w-[23%] bg-[#EFEDE0] border-2 border-[#F8D6BF] rounded-[34px] p-3"
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-[343px] object-cover rounded-[28px] cursor-pointer hover:scale-105 transition"
                    onClick={() => setZoomImage(item.image)}
                  />
                  <p className="mt-3 text-sm font-semibold text-center">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>



          {/* Monuments Section - shown only in photo */}
          <div className="px-4 sm:px-6 md:px-12 lg:px-16 py-12 mb-20">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-6 text-center">
              {t.heading2}
            </h2>

            <div className="flex flex-wrap justify-center gap-6">
              {monumentItems.map((item) => (
                <div
                  key={item.id}
                  className="w-full sm:w-[48%] md:w-[30%] lg:w-[23%] bg-[#EFEDE0] border-2 border-[#F8D6BF] rounded-[34px] p-3"
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-[343px] object-cover rounded-[28px] cursor-pointer hover:scale-105 transition"
                    onClick={() => setZoomImage(item.image)}
                  />
                  <p className="mt-3 text-sm text-center">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        // Show "Coming Soon" for Video + Event Gallery
        <div className="py-20">
          <p className="text-center text-2xl font-semibold text-gray-600">
            {t.heading5}

          </p>
        </div>
      )}

      {/* ZOOM MODAL */}
      {zoomImage && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4"
          onClick={() => setZoomImage(null)}
        >
          {/* Image Wrapper */}
          <div
            className="relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button on Image */}
            <button
              className="absolute -top-3 -right-3 bg-white text-black w-9 h-9 rounded-full flex items-center justify-center text-xl font-bold shadow-lg hover:bg-red-500 hover:text-white transition"
              onClick={() => setZoomImage(null)}
            >
              ✕
            </button>

            {/* Zoom Image */}
            <img
              src={zoomImage}
              alt="Zoom"
              className="max-w-full max-h-[90vh] rounded-lg shadow-lg animate-zoomIn"
            />
          </div>
        </div>
      )}

    </div>
  );
};

export default Gallery;
